import dayjs from 'dayjs';

export const getDateString = (date: string) => {
  const todaysDate = dayjs(new Date());
  if (todaysDate.diff(date, 'minute') < 60) {
    const noun = todaysDate.diff(date, 'minute') == 1 ? 'minute' : 'minutes';
    return `${todaysDate.diff(date, 'minute')} ${noun} ago`;
  } else if (todaysDate.diff(date, 'hour') < 24) {
    const noun = todaysDate.diff(date, 'hour') == 1 ? 'hour' : 'hours';
    return `${todaysDate.diff(date, 'hour')} ${noun} ago`;
  } else if (todaysDate.diff(date, 'day') < 31) {
    const noun = todaysDate.diff(date, 'day') == 1 ? 'day' : 'days';
    return `${todaysDate.diff(date, 'day')} ${noun} ago`;
  } else if (todaysDate.diff(date, 'month') < 12) {
    const noun = todaysDate.diff(date, 'month') == 1 ? 'month' : 'months';
    return `${todaysDate.diff(date, 'month')} ${noun} ago`;
  } else {
    const noun = todaysDate.diff(date, 'year') == 1 ? 'year' : 'years';
    return `${todaysDate.diff(date, 'year')} ${noun} ago`;
  }
};

export const getDateStringShort = (date: string) => {
  const todaysDate = dayjs(new Date());
  if (todaysDate.diff(date, 'minute') < 60) {
    return `${todaysDate.diff(date, 'minute')}min ago`;
  } else if (todaysDate.diff(date, 'hour') < 24) {
    return `${todaysDate.diff(date, 'hour')}hr ago`;
  } else if (todaysDate.diff(date, 'day') < 31) {
    return `${todaysDate.diff(date, 'day')}d ago`;
  } else if (todaysDate.diff(date, 'month') < 12) {
    return `${todaysDate.diff(date, 'month')}m ago`;
  } else {
    return `${todaysDate.diff(date, 'year')}yr ago`;
  }
};
